var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.allowCopyPaste)?_c('v-btn',{class:_vm.cssClass,attrs:{"icon":_vm.mode === 'icon'},on:{"click":_vm.copyToClipboard}},[_c('v-icon',[_vm._v(_vm._s(_vm.icons.mdiContentCopy))]),(_vm.mode !== 'icon')?[_c('mrx-translation',{attrs:{"token":_vm.translationToken}})]:_vm._e()],2):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }